// Maps AgentEscalationReason#icon_key (string) to a lucide-react icon
// component. Keys MUST stay in lockstep with
// AgentEscalationReason::ICON_CATALOG on the BE — adding one without the
// other will fall back to HelpCircle here, so a stale FE renders a
// generic icon instead of crashing.

import {
  AlertTriangle,
  Ban,
  Bug,
  Clock,
  Coins,
  CreditCard,
  FileText,
  Gift,
  HelpCircle,
  Key,
  Lock,
  Mail,
  Megaphone,
  MessageCircle,
  Package,
  RotateCcw,
  Settings,
  ShieldAlert,
  Trash2,
  User,
  type LucideIcon,
} from "lucide-react"

const ICON_MAP: Record<string, LucideIcon> = {
  alert_triangle: AlertTriangle,
  ban:            Ban,
  bug:            Bug,
  clock:          Clock,
  coins:          Coins,
  credit_card:    CreditCard,
  file_text:      FileText,
  gift:           Gift,
  help_circle:    HelpCircle,
  key:            Key,
  lock:           Lock,
  mail:           Mail,
  megaphone:      Megaphone,
  message_circle: MessageCircle,
  package:        Package,
  rotate_ccw:     RotateCcw,
  settings:       Settings,
  shield_alert:   ShieldAlert,
  trash_2:        Trash2,
  user:           User,
}

export function escalationReasonIcon(key: string | null | undefined): LucideIcon {
  if (!key) return HelpCircle
  return ICON_MAP[key] ?? HelpCircle
}
